import * as React from 'react';
import { FC } from 'react';

import { useIntl } from 'react-intl';

import { Container, Content, Header } from './loyalty-history-widget.styled';

const LoyaltyHistoryWidgetWrapper: FC = ({ children }) => {
  const { formatMessage } = useIntl();

  return (
    <Container data-testid="history-widget">
      <Content>
        <Header>{formatMessage({ id: 'recentHistory' })}</Header>
        {children}
      </Content>
    </Container>
  );
};

export default LoyaltyHistoryWidgetWrapper;
